import { api, unwrap, toPaginated } from "../lib/axios";
import type { ApiEnvelope, PaginatedResult } from "../types/api";
import type { RideType } from "../types/domain";

export interface PricingBreakdown {
  estimatedFare: number;
  breakdown: {
    baseFare: number;
    distanceFare: number;
    timeFare: number;
    waitingFee: number;
  };
  currency: string;
}

export const rideTypesApi = {
  async list(params: {
    isActive?: boolean;
    vehicleType?: string;
  } = {}): Promise<PaginatedResult<RideType>> {
    const res = await api.get<ApiEnvelope<unknown>>("/vehicle-category", {
      params,
    });
    return toPaginated<RideType>(res, "rideTypes");
  },

  async get(id: string): Promise<RideType> {
    const res = await api.get<ApiEnvelope<RideType>>(`/vehicle-category/${id}`);
    return unwrap(res);
  },

  async create(body: Partial<RideType>): Promise<RideType> {
    const res = await api.post<ApiEnvelope<RideType>>("/vehicle-category", body);
    return unwrap(res);
  },

  async update(id: string, body: Partial<RideType>): Promise<RideType> {
    const res = await api.patch<ApiEnvelope<RideType>>(
      `/vehicle-category/${id}`,
      body,
    );
    return unwrap(res);
  },

  async remove(id: string): Promise<void> {
    await api.delete(`/vehicle-category/${id}`);
  },

  async calculatePricing(params: {
    rideTypeId: string;
    distance: number;
    duration?: number;
    waitingTime?: number;
  }): Promise<PricingBreakdown> {
    const res = await api.get<ApiEnvelope<PricingBreakdown>>(
      "/vehicle-category/calculate-pricing",
      { params },
    );
    return unwrap(res);
  },
};
